"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorCompanyInfoPageActions = exports.VendorCompanyInfoPage = void 0;
var vendorCompanyInfoPage_1 = require("./vendorCompanyInfoPage");
exports.VendorCompanyInfoPage = vendorCompanyInfoPage_1.default;
var vendorCompanyInfoPageActions_1 = require("./vendorCompanyInfoPageActions");
exports.VendorCompanyInfoPageActions = vendorCompanyInfoPageActions_1.default;
